// Search overlay functionality
const searchOverlay = document.getElementById("searchOverlay");
const searchClose = document.getElementById("searchClose");
const searchInput = document.getElementById("searchInput") as HTMLInputElement;
const searchResults = document.getElementById("searchResults");
const searchTriggers = document.querySelectorAll(".js-search-trigger");

let debounceTimer: ReturnType<typeof setTimeout>;

function openSearch() {
    if (searchOverlay) {
        searchOverlay.classList.add("is-active");
        document.body.classList.add("search-open");
        setTimeout(() => searchInput?.focus(), 100);
    }
}

function closeSearch() {
    if (searchOverlay) {
        searchOverlay.classList.remove("is-active");
        document.body.classList.remove("search-open");
        if (searchInput) searchInput.value = "";
        if (searchResults) searchResults.innerHTML = "";
    }
}

// Open search on trigger click
searchTriggers.forEach(trigger => {
    trigger.addEventListener("click", (e) => {
        e.preventDefault();
        openSearch();
    });
});

// Close search
if (searchClose) {
    searchClose.addEventListener("click", closeSearch);
}

// Close on overlay background click
if (searchOverlay) {
    searchOverlay.addEventListener("click", (e) => {
        if (e.target === searchOverlay) {
            closeSearch();
        }
    });
}

// Close on Escape key
document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && searchOverlay?.classList.contains("is-active")) {
        closeSearch();
    }
});

// AJAX search with debounce
if (searchInput && searchResults) {
    searchInput.addEventListener("input", () => {
        clearTimeout(debounceTimer);
        const query = searchInput.value.trim();

        if (query.length < 2) {
            searchResults.innerHTML = "";
            return;
        }

        searchResults.innerHTML = '<p class="search-overlay__message">Searching...</p>';

        debounceTimer = setTimeout(() => {
            const url = `${origin_ajax.ajax_url}?action=smj_product_search&nonce=${origin_ajax.nonce}&s=${encodeURIComponent(query)}`;

            fetch(url)
                .then(res => res.json())
                .then(response => {
                    if (!response.success || response.data.length === 0) {
                        searchResults.innerHTML = '<p class="search-overlay__message">No products found.</p>';
                        return;
                    }

                    let html = "";
                    response.data.forEach((item: { title: string; url: string; price: string; thumbnail: string }) => {
                        const thumb = item.thumbnail
                            ? `<img src="${item.thumbnail}" alt="${item.title}">`
                            : "";
                        html += `
                            <a href="${item.url}" class="search-overlay__item">
                                ${thumb}
                                <div class="search-overlay__item-info">
                                    <span class="search-overlay__item-title">${item.title}</span>
                                    <span class="search-overlay__item-price">${item.price}</span>
                                </div>
                            </a>
                        `;
                    });

                    // Add "View all results" link
                    html += `<a href="/?s=${encodeURIComponent(query)}&post_type=product" class="search-overlay__all">View all results &rarr;</a>`;

                    searchResults.innerHTML = html;
                })
                .catch(() => {
                    searchResults.innerHTML = '<p class="search-overlay__message">Something went wrong. Please try again.</p>';
                });
        }, 300);
    });
}
